import { useInvalidateCurrentCloudCart, usePollCloudCart } from '@/entities/cloud-carts';

export const CloudCartBehavior = () => {
  usePollCloudCart();
  useInvalidateCurrentCloudCart();

  return null;
};
